import { Injectable } from "@angular/core";
import { MaintenanceControlsDbDao } from "../dao/db/maintenanceControls.db.dao";
import { MaintenanceControlsWsDao } from "../dao/ws/maintenanceControls.ws.dao";
import { MaintenanceControlDto } from "../dto/maintenanceControl.dto";
import { ServersConnectionsProvider } from "../providers/serversConnections.provider";

@Injectable({
    providedIn: "root",
})
export class MaintenanceControlsService {
    constructor(private maintenanceControlsWsDao: MaintenanceControlsWsDao,
                private maintenanceControlsDbDao: MaintenanceControlsDbDao,
                private serversConnectionsProvider: ServersConnectionsProvider) {
    }

    public async synchronizeForEquipment(equipmentId: string, inspectionId: string): Promise<MaintenanceControlDto[]> {
        let maintenanceControls = await this.maintenanceControlsWsDao.listByEquipment(this.serversConnectionsProvider.getPrimaryServerConnection(),
            equipmentId,
            inspectionId);

        for (let maintenanceControl of maintenanceControls) {
            await this.maintenanceControlsDbDao.save(maintenanceControl.toModel());
        }

        return maintenanceControls;
    }

    public async saveList(equipmentId: string, inspectionId: string, internalId: string, maintenanceControls: MaintenanceControlDto[]): Promise<MaintenanceControlDto[]> {
        return this.maintenanceControlsWsDao.saveList(this.serversConnectionsProvider.getPrimaryServerConnection(), equipmentId, inspectionId, internalId, maintenanceControls);
    }

    public async listForEquipmentOffline(equipmentId: string): Promise<MaintenanceControlDto[]> {
        let maintenanceControls = await this.maintenanceControlsDbDao.listForEquipment(equipmentId);

        return maintenanceControls.map(maintenanceControl => {
            return MaintenanceControlDto.fromModel(maintenanceControl);
        });
    }
}
